import { render } from "./blogdetails.vue?vue&type=template&id=7d2c435c"
import script from "./blogdetails.vue?vue&type=script&lang=js"
export * from "./blogdetails.vue?vue&type=script&lang=js"

import "./blogdetails.vue?vue&type=style&index=0&id=7d2c435c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__